import { render, staticRenderFns } from "./tr-loading.vue?vue&type=template&id=b0bfcad2&"
import script from "./tr-loading.vue?vue&type=script&lang=js&"
export * from "./tr-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports